export const GROUP_NO_LONGER_EXISTS_TEXT = {
    titleMessage: "The host has ended this Group Order",
    statusMessage: "The shared cart is no longer available",
};

export const ORDER_ON_THE_WAY_COMMS = {
    TITLE: "Wohoo!! ",
    SUBTITLE: "Your group order has been placed!",
};

export const GROUP_CART_HAS_LOCKED_TEXT = "Host has locked the cart for checkout";
export const GO_BACK_CTA_TEXT = "Go back";

export const CONTINUE_TO_CHECKOUT = "Continue to checkout";
export const GUESTS_CANT_EDIT = "Only you can edit items after you proceed";

export const INVITE_MORE = "Invite More";
export const LEAVE_GROUP = "Leave Group";
export const REFRESH = "Refresh";

export const HEADER_TITLE = "{0}'s Group Order";
export const YOUR_GROUP_ORDER = "Your Group Order";
export const HEADER_MULTIPLE_MEMBER_SUBTITLE = "{0} people • {1} ({2})";
export const HEADER_SINGLE_MEMBER_SUBTITLE = "1 person • {1} ({2})";
export const START_ADDING_ITEMS = "Start adding items";
export const ADD_MORE_ITEMS = "Add More Items";

export const NO_ITEMS_ADDED = "No items added";
export const NO_ITEMS_ADDED_YET = "No items added yet!";

export const LEAVE_GROUP_ICON_URL = "portal/testing/group-cart/LeaveGroup.png";
export const INVITE_GROUP_ICON_URL = "portal/testing/group-cart/InviteMore.png";
export const GUEST_BOTTOM_FOOTER_SRC = "portal/testing/group-cart/guestBottomFooter.png";

export const GROUP_CART_GENERIC_ERROR = "group_cart_generic_error";

export const GUEST_FOOTER_TITLE = "Sit back and relax! ";
export const GUEST_FOOTER_SUBTITLE = "Host will do the rest";
